import { loadScanware } from '@/actions/loadScanware';
import { ECampaign, EUserFlow } from '@/context/borrower';
import {
    EJourneys,
    EModals,
    setModal,
    setScanwareQrId,
    setShowScanwarePopup,
} from '@/context/display';
import { store } from '@/context/store';
import { EPartners } from '@/partners/partnerTypes';
import { IParameter } from '@/utils/setParametersFromParams';

import { getInitialModalScreen } from '../getInitialModalScreen';

export function setInitialModal(
    partnerId: EPartners,
    paramQrScanwareId: IParameter,
    initialJourney: EJourneys,
    userFlow: EUserFlow
): void {
    // Special case: QR code + test drive + unknown vehicle should show stock capture modal
    if (initialJourney === EJourneys.TEST_DRIVE && paramQrScanwareId) {
        // Check if vehicle is unknown by checking Redux state after it's been loaded
        const state = store.getState();
        const { isVehicleKnown } = state.borrowerReducer.vehicle;

        // If Redux doesn't know the vehicle, show stock capture modal
        if (!isVehicleKnown) {
            store.dispatch(setShowScanwarePopup(true));
            store.dispatch(setScanwareQrId(paramQrScanwareId));
            store.dispatch(setModal(EModals.IMOTOR_STOCK));
            loadScanware();
            return;
        }
    }

    // hardcoded no modal for test drive journey (when no QR code)
    if (initialJourney === EJourneys.TEST_DRIVE) {
        store.dispatch(setModal(null));
        return;
    }
    // hardcoded campaign disclaimer modal for campaign journey
    if (userFlow === EUserFlow.CAMPAIGN) {
        // todo This should be moved to config! Hardcoded cause 4 hours notice =(
        const campaign = store.getState().displayReducer.partner.campaign;
        if (campaign === ECampaign.YAMAHA) {
            store.dispatch(setModal(null));
            return;
        } else {
            store.dispatch(setModal(EModals.CAMPAIGN_DISCLAIMER));
            return;
        }
    }

    const state = store.getState();
    const { showWelcomeScreen, modal } = state.displayReducer;
    const { isLoggedIn } = state.userReducer;

    let modalToSet: EModals | null = null;

    if (paramQrScanwareId) {
        store.dispatch(setShowScanwarePopup(true));
        store.dispatch(setScanwareQrId(paramQrScanwareId));

        modalToSet = EModals.IMOTOR_STOCK;
        loadScanware();
    } else if (showWelcomeScreen && isLoggedIn) {
        store.dispatch(setModal(EModals.DEALERSHIP_WELCOME));
        modalToSet = EModals.DEALERSHIP_WELCOME;
        return;
    } else {
        modalToSet = getInitialModalScreen();
    }

    if (modalToSet === modal) return;
    store.dispatch(setModal(modalToSet));
}
